import { Text } from "@chakra-ui/react";
import { Link } from "react-router";

interface NavLinkProps {
  linkText: string;
  navTo: string;
  onClick?: () => void;
}

export const NavLink = ({ linkText, navTo, onClick }: NavLinkProps) => {
  return (
    <Text
      as={Link}
      to={navTo}
      p={6}
      mx={3}
      color="#9251f5"
      border="1px solid transparent"
      _hover={{
        borderColor: "cyan",
        borderRadius: "25px",
        color: "#2fd5e0",
      }}
      textAlign="center"
      w="90%"
      onClick={onClick}
    >
      {linkText}
    </Text>
  );
};
